import { Zap } from 'lucide-react';

const ContentBadge = ({ text }) => {
  return (
    <div className="inline-flex items-center gap-2 bg-[#E2E8F0] text-[#020617] py-2 px-4 sm:px-6 rounded-lg font-gilroy-medium text-xs sm:text-[16px] leading-4 sm:leading-[22px] tracking-[0.02em] uppercase">
      <Zap className="w-3 h-3 sm:w-4 sm:h-4 fill-[#020617]" />
      {text}
      <Zap className="w-3 h-3 sm:w-4 sm:h-4 fill-[#020617]" />
    </div>
  );
};

export default ContentBadge;
